const http = require('../lib/httpClient');
const { OTP, COMMERCE_HEADER } = require('../constants');
const { getChannelId, getEcommId, getXCommerceValue } = require('../lib/browserData');

const catalystOtpByError = {
  code: 'CATALYST_GET_OTP_BY_EMAIL_ERROR',
  message: 'Unable to get otp by email',
};

const endpoint = '/s/auth/v1/otp/email';

async function catalystOtpByEmail(emailAddress, tenantId, catalystBaseUrl = '', otpFlow = false) {
  const operationType = otpFlow
    ? OTP.OPERATION_TYPE.OTP_NEW_REGISTERED_DEVICE
    : OTP.OPERATION_TYPE.TEMPORARY_PASS;
  const result = await http.post(
    `${catalystBaseUrl}${endpoint}`,
    { operationType, emailAddress },
    {
      otpFlow,
      headers: {
        'x-channel-id': getChannelId(),
        'x-ecomm-name': getEcommId(tenantId),
        'x-commerce': getXCommerceValue(catalystBaseUrl) || COMMERCE_HEADER,
      },
    },
  );

  const { responseBody } = result || {};

  if (!responseBody) return { data: undefined, errors: [catalystOtpByError] };
  const { success, errors } = responseBody;
  if (errors) return { data: undefined, errors };
  if (!success) {
    return {
      data: undefined,
      errors: [catalystOtpByError],
    };
  }
  return { data: { success }, errors: [] };
}

module.exports = catalystOtpByEmail;
